import React, { Component } from "react";
import PropTypes from "prop-types";
import ArTheme from "../argon-ui/Theme";
import { View, Text, ScrollView, StyleSheet } from "react-native";
import { IconButton } from "./Buttons";
import * as faCharCodes from "../../assets/consts/faCharCodes";
/**@augments{Component<Props,state>} */
class HorizontalIconPicker extends Component {
  static propTypes = {
    icons: PropTypes.array.isRequired,
    selectedIcon: PropTypes.string,
    onSelect: PropTypes.func,
    style: PropTypes.shape(),
  };
  constructor(props) {
    super(props);
    let { selectedIcon } = this.props;
    this.state = {
      selectedIcon,
    };
  }

  handleOnSelect = (icon) => {
    this.setState({ selectedIcon: icon }, () => {
      typeof this.props.onSelect === "function" && this.props.onSelect(icon);
    });
  };

  render() {
    let { style, icons } = this.props;
    if (!style) style = {};
    if (!Array.isArray(icons) || !icons.length) {
      return null;
    }
    return (
      <ScrollView horizontal style={[styles.container, style]}>
        {this.props.icons.map((ic, idx) => (
          <IconButton
            key={idx}
            onPress={() => {
              this.handleOnSelect(ic);
            }}
            style={styles.button}
            icon={{
              code: ic,
              style: {
                color:
                  this.state.selectedIcon == ic
                    ? ArTheme.COLORS.ACTIVE
                    : ArTheme.COLORS.MUTED,
                fontFamily:
                  this.state.selectedIcon == ic
                    ? faCharCodes.FONT_FAMILIES.PRO_REGULAR
                    : faCharCodes.FONT_FAMILIES.PRO_LIGHT,
                fontSize: 27,
              },
            }}
          />
        ))}
      </ScrollView>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    backgroundColor: ArTheme.COLORS.BORDER_COLOR,
    paddingVertical: 5,
  },
  button: {
    borderWidth: 1,
    borderColor: ArTheme.COLORS.BORDER,
    width: 42,
    height: 42,
    borderRadius: 5,
    margin: 3,
    backgroundColor: "#FFF",
    justifyContent: "center",
  },
});

export default HorizontalIconPicker;
